import classNames from 'classnames';
import { useTranslation } from 'next-i18next';

import { ProductV2Storyblok } from '../../../types/generated-storyblok';

type ProductEditionSizeProps = {
  editionNote?: string;
  editionSize?: string | number;
  editionFormat?: ProductV2Storyblok['editionFormat'];
  hasReleaseCollectionGallery?: boolean;
  onAnchorButtonClick?: () => void;
  className?: string;
};

export const ProductEditionSize = ({
  className,
  editionFormat,
  editionNote,
  editionSize,
  hasReleaseCollectionGallery,
  onAnchorButtonClick,
}: ProductEditionSizeProps) => {
  const { t } = useTranslation('product');

  const amount = editionSize
    ? typeof editionSize === 'number'
      ? editionSize
      : parseInt(editionSize, 10)
    : 0;

  const editionSizeV2 = (() => {
    switch (editionFormat) {
      case 'limited':
        return t('productDetails.editionSize.limited', { amount });
      case 'series':
        return t('productDetails.editionSize.series', { amount });
      case 'timed':
        return amount > 0
          ? t('productDetails.editionSize.limited', { amount })
          : t('productDetails.editionSize.timed');
      default:
        return null;
    }
  })();

  if (amount === 0 && !editionSizeV2 && !editionNote) return null;

  return (
    <span className={classNames('text-balance', className)}>
      {editionSizeV2 || (amount ? t('editionSize', { amount }) : editionNote)}

      {hasReleaseCollectionGallery && onAnchorButtonClick && (
        <>
          <span aria-hidden="true" className="mx-1 before:content-['·']" />
          <button
            className="hyperlink"
            onClick={onAnchorButtonClick}
            type="button"
          >
            {t('releaseCollectionGalleryHeading')}
          </button>
        </>
      )}
    </span>
  );
};
